export default __webpack_public_path__ + "static/Крысиные бега_6-d46c677bb1887ccbe436384706b46364.jpg";